import { atom } from "jotai"
import { selectedReserveAddressAtom } from "./pools"
import { selectedPoolAtom } from "./shared"

export const selectedReserveAtom = atom(
  (get) => {
    const pool = get(selectedPoolAtom)
    const selectedReserveAddress = get(selectedReserveAddressAtom)
    const reserve = pool?.reserves?.find((r) => r.address === selectedReserveAddress)
    return reserve
  },
  (_get, set, newSelectedPoolAddress: string | null) => {
    set(selectedReserveAddressAtom, newSelectedPoolAddress)
  },
)

export const selectedModalTabAtom = atom(0)

export const modalAmountAtom = atom<number | undefined>(0)
